<template>
    <div class="min-h-screen bg-[#F9F9FB] font-sans text-[#111]">
        
        <header class="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-xl border-b border-gray-100">
            <div class="flex items-center justify-between px-6 py-4">
                <div class="flex items-center gap-4">
                    <button 
                        class="p-2 rounded-lg text-black hover:bg-gray-100 md:hidden transition-colors" 
                        @click="sidebarOpen = true">
                        <i class="fas fa-bars text-xl"></i>
                    </button>

                    <div class="flex items-center gap-3 group cursor-pointer" onclick="window.location.href='/app'">
                        <img src="https://storage.victoranw.fr/file/hGf4I3ecnS" class="h-10" alt="TermoFlow">
                        <span class="font-black text-xl tracking-tighter text-black">TermoFlow</span>
                    </div>
                </div>

                <div class="flex items-center gap-2">
                    <button v-if="$account.account.super_admin || $account.account.commercial" @click="$router.push({name: 'ChooseSpace'})"
                        class="flex items-center gap-2 bg-purple-50 border border-purple-200 text-purple-700 text-xs font-semibold px-3 py-1.5 rounded-md hover:bg-purple-100 transition-colors">
                        <i class="fas fa-share text-xs"></i> Changer d'espace
                    </button>
                    <div class="px-4 py-2 rounded-full bg-gradient-to-r from-red-500 to-orange-500 text-white text-xs font-bold uppercase tracking-wide">
                        Espace Administrateur
                    </div>
                </div>
                
            </div>
        </header>

        <div 
            v-if="sidebarOpen" 
            class="fixed inset-0 bg-black/40 backdrop-blur-sm z-40 md:hidden transition-opacity duration-300" 
            @click="sidebarOpen = false">
        </div>

        <aside 
            class="fixed top-0 left-0 z-50 h-screen w-[280px] bg-white border-r border-gray-100 transform transition-transform duration-300 md:translate-x-0"
            :class="sidebarOpen ? 'translate-x-0' : '-translate-x-full'">
            
            <div class="relative h-full flex flex-col">
                <div class="p-6 pb-2">
                    <div class="flex items-center gap-2.5">
                        <img src="https://storage.victoranw.fr/file/hGf4I3ecnS" class="h-[30px]" alt="TermoFlow">
                        <span class="text-2xl tracking-tighter font-black text-black">TermoFlow</span>
                    </div>
                </div>

                <nav class="flex-1 overflow-y-auto px-4 py-2 space-y-1">

                    <div class="px-2 mb-2 mt-2">
                        <span class="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Menu Principal</span>
                    </div>

                    <a 
                        href="/admin" 
                        class="group relative px-4 py-3 rounded-xl transition-all duration-200 flex items-center gap-3" 
                        :class="currentRouteKey == 'home' ? 'bg-gradient-to-r from-red-500 to-orange-500 text-white font-bold' : 'text-gray-500 hover:bg-gray-50 hover:text-black'">
                        <i class="fas fa-home text-sm" :class="currentRouteKey == 'home' ? 'text-white' : 'text-gray-400 group-hover:text-black'"></i>
                        <span class="text-sm">Accueil</span>
                    </a>

                    <div class="px-2 mb-2 mt-2">
                        <span class="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Clients</span>
                    </div>

                    <a 
                        href="/admin/societes/init" 
                        class="group relative px-4 py-3 rounded-xl transition-all duration-200 flex items-center gap-3" 
                        :class="currentRouteKey == 'societes-init' ? 'bg-gradient-to-r from-red-500 to-orange-500 text-white font-bold' : 'text-gray-500 hover:bg-gray-50 hover:text-black'">
                        <i class="fas fa-user-plus text-sm" :class="currentRouteKey == 'societes-init' ? 'text-white' : 'text-gray-400 group-hover:text-black'"></i>
                        <span class="text-sm">Nouveau client</span>
                    </a>

                    <a 
                        href="/admin/societes" 
                        class="group relative px-4 py-3 rounded-xl transition-all duration-200 flex items-center gap-3" 
                        :class="currentRouteKey == 'societes' ? 'bg-gradient-to-r from-red-500 to-orange-500 text-white font-bold' : 'text-gray-500 hover:bg-gray-50 hover:text-black'">
                        <i class="fas fa-building text-sm" :class="currentRouteKey == 'societes' ? 'text-white' : 'text-gray-400 group-hover:text-black'"></i>
                        <span class="text-sm">Sociétés</span>
                    </a>

                    <div class="px-2 mb-2 mt-2">
                        <span class="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Blog</span>
                    </div>

                    <a 
                        href="/admin/blog" 
                        class="group relative px-4 py-3 rounded-xl transition-all duration-200 flex items-center gap-3" 
                        :class="currentRouteKey == 'blog' ? 'bg-gradient-to-r from-red-500 to-orange-500 text-white font-bold' : 'text-gray-500 hover:bg-gray-50 hover:text-black'">
                        <i class="fas fa-newspaper text-sm" :class="currentRouteKey == 'blog' ? 'text-white' : 'text-gray-400 group-hover:text-black'"></i>
                        <span class="text-sm">Blog</span>
                    </a>

                    <template v-if="$account.account.email == 'contact@victoranw.fr' || isLocalHost">
                        <div class="px-2 mb-2 mt-2">
                            <span class="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Commerciaux</span>
                        </div>
                        <a 
                            href="/admin/commerciaux" 
                            class="group relative px-4 py-3 rounded-xl transition-all duration-200 flex items-center gap-3" 
                            :class="currentRouteKey == 'commerciaux' ? 'bg-gradient-to-r from-red-500 to-orange-500 text-white font-bold' : 'text-gray-500 hover:bg-gray-50 hover:text-black'">
                            <i class="fas fa-chart-line text-sm" :class="currentRouteKey == 'commerciaux' ? 'text-white' : 'text-gray-400 group-hover:text-black'"></i>
                            <span class="text-sm">Dashboard</span>
                        </a>
    
                        <a 
                            href="/admin/commerciaux/liste" 
                            class="group relative px-4 py-3 rounded-xl transition-all duration-200 flex items-center gap-3" 
                            :class="currentRouteKey == 'commerciaux-liste' ? 'bg-gradient-to-r from-red-500 to-orange-500 text-white font-bold' : 'text-gray-500 hover:bg-gray-50 hover:text-black'">
                            <i class="fas fa-users text-sm" :class="currentRouteKey == 'commerciaux-liste' ? 'text-white' : 'text-gray-400 group-hover:text-black'"></i>
                            <span class="text-sm">Commerciaux</span>
                        </a>
    
                        <a 
                            href="/admin/commerciaux/paiements" 
                            class="group relative px-4 py-3 rounded-xl transition-all duration-200 flex items-center gap-3" 
                            :class="currentRouteKey == 'commerciaux-paiements' ? 'bg-gradient-to-r from-red-500 to-orange-500 text-white font-bold' : 'text-gray-500 hover:bg-gray-50 hover:text-black'">
                            <i class="fas fa-wallet text-sm" :class="currentRouteKey == 'commerciaux-paiements' ? 'text-white' : 'text-gray-400 group-hover:text-black'"></i>
                            <span class="text-sm">Paiements</span>
                        </a>

                    </template>
                    <div class="px-2 mb-2 mt-2">
                        <span class="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Outils</span>
                    </div>
                    <a 
                        href="/admin/upload-fichier" 
                        class="group relative px-4 py-3 rounded-xl transition-all duration-200 flex items-center gap-3" 
                        :class="currentRouteKey == 'upload-fichier' ? 'bg-gradient-to-r from-red-500 to-orange-500 text-white font-bold' : 'text-gray-500 hover:bg-gray-50 hover:text-black'">
                        <i class="fas fa-upload text-sm" :class="currentRouteKey == 'upload-fichier' ? 'text-white' : 'text-gray-400 group-hover:text-black'"></i>
                        <span class="text-sm">Upload Fichier</span>
                    </a>
                </nav>

                <div class="p-4 border-t border-gray-100 bg-white">
                    <div @click="logout" class="flex items-center gap-3 p-3 rounded-2xl border border-transparent hover:border-gray-100 hover:bg-gray-50 transition cursor-pointer group">
                        <div class="relative">
                            <div class="w-9 h-9 rounded-full bg-black text-white flex items-center justify-center font-bold text-xs ring-2 ring-transparent group-hover:ring-red-200 transition-all">
                                {{ ($account.account.prenom.charAt(0) + $account.account.nom.charAt(0)).toUpperCase() }}
                            </div>
                            <div class="absolute -bottom-0.5 -right-0.5 w-3 h-3 bg-red-500 border-2 border-white rounded-full"></div>
                        </div>
                        <div class="flex-1 overflow-hidden">
                            <div class="text-sm text-black truncate">{{ $account.account.prenom + ' ' + $account.account.nom }}</div>
                            <div class="text-[10px] font-bold text-red-600 uppercase tracking-wide">Connecté</div>
                        </div>
                    </div>
                </div>
            </div>
        </aside>

        <main class="mt-[76px] md:pl-[300px] p-6 min-h-[calc(100vh-76px)] transition-all">
            <div class="max-w-[1350px] mx-auto">
                <slot></slot>
            </div>
        </main>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    name: "AppTemplate",
    data() {
        return {
            sidebarOpen: false,
        }
    },
    computed: {
        currentRouteKey() {
            let routeName = this.$route.name;
            let keyGroup = {
                AdminDashboard: 'home',
                AdminSocietes: 'societes',
                AdminSocieteView: 'societes',
                AdminSocietesInit: 'societes-init',
            };
            return keyGroup[routeName] || '';
        },

        isLocalHost() {
            return window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
        }
    },
    filters: {
        momentDate(value) {
            if (!value) {
                return '-';
            }
            return moment(value).format('DD/MM/YYYY');
        }
    },
    methods: {
        logout() {
            localStorage.removeItem('auth-token');
            window.location.href = '/login';
        }
    }
}
</script>

<style scoped>
/* Smooth scrollbar */
aside::-webkit-scrollbar {
    width: 6px;
}

aside::-webkit-scrollbar-track {
    background: transparent;
}

aside::-webkit-scrollbar-thumb {
    background: linear-gradient(to bottom, #6366f1, #a855f7);
    border-radius: 10px;
}

aside::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(to bottom, #4f46e5, #9333ea);
}
</style>
